var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendiente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ESSENTIAL_UI",
    "data-name": "ESSENTIAL UI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-141.38 0-256 114.61-256 256s114.62 256 256 256 256-114.62 256-256-114.61-256-256-256z",
    fill: "#4193d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.56 400.82c153.63 0 278.17-124.54 278.17-278.16a277.77 277.77 0 0 0 -14.28-88.14 254.83 254.83 0 0 0 -128.45-34.52c-141.38 0-256 114.62-256 256a254.81 254.81 0 0 0 36.57 131.91 278.14 278.14 0 0 0 83.99 12.91z",
    fill: "#48a4df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.89 256a28.36 28.36 0 0 1 -28.36 28.36h-107.53a28.35 28.35 0 0 1 -28.36-28.36v-166.79a28.36 28.36 0 0 1 56.72 0v138.43h79.17a28.36 28.36 0 0 1 28.36 28.36z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendiente);
export default __webpack_public_path__ + "static/media/pendiente.f0d014a961258ce198bd3105935505f5.svg";
export { ForwardRef as ReactComponent };